import { React, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// material
import { CircularProgress, Box, Typography  } from '@mui/material';
// -------------------------------------------------------------------------------------------------

LoadingProgressBar.propTypes = {
    sx: PropTypes.object
};

const style = {
    position: "fixed",
    left: "50%",
    top: "50%",
    color:"#E7000B"
};

    function CircularProgressWithLabel(props) {
        return (
            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                <CircularProgress variant="determinate" {...props} />
                
            </Box>
        );
    }

    CircularProgressWithLabel.propTypes = {
        /**
         * The value of the progress indicator for the determinate variant.
         * Value between 0 and 100.
         * @default 0
         */
        value: PropTypes.number.isRequired,
    };

export default function LoadingProgressBar() {
        const [progress, setProgress] = useState(10);

        useEffect(() => {
            const timer = setInterval(() => {
                setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
            }, 800);
            return () => {
                clearInterval(timer);
            };
        }, []);

    return <CircularProgressWithLabel value={progress} sx={ style} />;
    }